/**
 * Bundle-template rules, pure — shared verbatim by the Bundle Builder (SPA,
 * via the package's subpath export) and the domain ops, so the two can't
 * disagree about how a pattern meets a size list. No DB, no clock.
 */

export const BUNDLE_TEMPLATE_NAME_MAX = 32;
/** Same ceiling as a scale's label count — a pattern longer than that is noise. */
export const BUNDLE_TEMPLATE_QUANTITIES_MAX = 24;

/**
 * Positional application of a pattern over a size list: `quantities[0]` maps
 * to the first size. A pattern shorter than the size list repeats its last
 * quantity — "cover every size" (spec 13 R2) must hold whatever the pattern's
 * length, and the tail of a dealer curve is its steady state. A longer
 * pattern ignores its extras.
 */
export function applyTemplate(
  quantities: readonly number[],
  sizes: readonly string[],
): Record<string, number> {
  const out: Record<string, number> = {};
  const last = quantities[quantities.length - 1] ?? 1;
  sizes.forEach((size, i) => {
    out[size] = quantities[i] ?? last;
  });
  return out;
}

/**
 * The five mockup presets, offered when the tenant has saved none of their
 * own. Applying one does NOT persist it — a tenant row is only written by
 * "Save as template".
 */
export const DEFAULT_BUNDLE_TEMPLATES: readonly {
  name: string;
  quantities: number[];
  colorMode?: "mixed" | "single";
}[] = [
  { name: "Retail Pack", quantities: [1, 2, 2, 1] },
  { name: "Summer Pack", quantities: [2, 2, 1, 1] },
  { name: "Festival Pack", quantities: [5, 5, 5, 5] },
  { name: "Premium Pack", quantities: [1, 1, 1, 1] },
  { name: "Mixed Color Pack", quantities: [2, 2, 2, 2], colorMode: "mixed" },
];
